/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsLocationListItem
 */
export interface DigitizingserviceMelcoDigitizingModelsLocationListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsLocationListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsLocationListItem
     */
    name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsLocationListItemFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsLocationListItem {
    return DigitizingserviceMelcoDigitizingModelsLocationListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsLocationListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsLocationListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsLocationListItemToJSON(value?: DigitizingserviceMelcoDigitizingModelsLocationListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


